export default new (class UrlGeneration {
    constructor() {
        this.sBaseURL = decodeURI(`${location.origin}${location.pathname}`);
        this.init();
    }

    init(bConcat = false) {
        this.sSearchString = decodeURIComponent(window.location.search.substring(1));
        this.obParamList = {};
        this.bConcat = bConcat;

        let arPartList = this.sSearchString.split("&");
        arPartList.forEach((sParam) => {
            let iPosition = sParam.indexOf("=");
            if (iPosition < 0) {
                return;
            }

            let sFiled = sParam.substring(0, iPosition),
                sValue = sParam.substring(iPosition + 1);
            if (!sFiled && !sValue) {
                return;
            }
            if (this.bConcat) {
                this.obParamList[sFiled] = sValue.split("|");
            } else {
                if (!this.obParamList[sFiled]?.length) {
                    this.obParamList[sFiled] = [];
                }
                this.obParamList[sFiled].push(sValue);
            }
        });
    }

    clear() {
        this.obParamList = {};

        history.pushState(null, null, `${this.sBaseURL}`);
    }

    update(bReplace = false) {
        this.generateSearchString();
        const method = bReplace ? 'replaceState' : 'pushState'

        if (Object.keys(this.obParamList).length > 0) {
            history[method](
                null,
                null,
                `${this.sBaseURL}?${this.sSearchString}`
            );
        } else {
            history[method](null, null, `${this.sBaseURL}`);
        }
    }

    generateSearchString() {
        let arFieldList = Object.keys(this.obParamList);

        this.sSearchString = "";
        arFieldList.forEach((sField) => {
            if (this.sSearchString.length > 0) {
                this.sSearchString += "&";
            }
            if (this.bConcat) {
                this.sSearchString += `${sField}=${this.obParamList[
                    sField
                ].join("|")}`;
            } else {
                this.obParamList[sField].forEach((sValue, index) => {
                    if (index > 0) {
                        this.sSearchString += "&";
                    }
                    this.sSearchString += `${sField}=${sValue}`;
                });
            }
        });
    }

    /**
     * Set field value in URL
     * @param sFiled
     * @param obValue
     */
    set(sFiled, obValue) {
        if (!sFiled || !obValue) {
            return;
        }
        if (this.bConcat) {
            if (typeof obValue == "string") {
                obValue = [obValue];
            }
            this.obParamList[sFiled] = obValue;
        } else {
            if (!this.obParamList[sFiled]?.length) {
                this.obParamList[sFiled] = [];
            }
            this.obParamList[sFiled].push(obValue);
        }

    }

    /**
     * Remove field value from URL
     * @param {string} sFiled
     */
    remove(sField) {
        if (!sField || !this.obParamList.hasOwnProperty(sField)) {
            return;
        }

        delete this.obParamList[sField];
    }
    removeValue(sField, sValue) {
        if (!sField || !this.obParamList.hasOwnProperty(sField)) {
            return;
        }

        this.obParamList[sField] = this.obParamList[sField].filter((value) => value != sValue);

        if (!this.obParamList[sField].length) this.remove(sField);
    }

    hasValue(sField, sValue) {
        if (!sField || !this.obParamList.hasOwnProperty(sField)) {
            return false;
        }
        return this.obParamList[sField].includes(sValue);
    }

    replace(sField, sValue) {
        if (!sField) {
            return
        }
        if (this.obParamList.hasOwnProperty(sField)) {
            this.remove(sField);
        }

        this.set(sField, sValue);
    }
})();
